$(document).ready(function(){
  $('.delivery_date_line').each(function(){
      var findDelay = $(this).find('.delivery_date_delay_checker').attr('data-delay');

      var delay = '';
      
      if (findDelay == 'none'){
          delay = 2;
          var dayCounter =  parseFloat(window.dayQty);
      }
      else{
          delay = parseFloat(findDelay);
          var dayCounter = delay + parseFloat(window.dayQty);
      }

      
      const today = new Date();

      const deliveryDate1 = addBusinessDays(today, delay);
      const deliveryDate2 = addBusinessDays(today, dayCounter);    
      
      const formattedDate1 = formatDate(deliveryDate1);
      const formattedDate2 = formatDate(deliveryDate2);

      const deliveryRange = `${formattedDate1} - ${formattedDate2}`;

      $(this).find('#delivery-date').html(deliveryRange);

  });

  function formatDate(date) {
      const options = { day: "numeric", month: "short" };
      return date.toLocaleDateString(`${window.dateLanguage}`, options);
  }

  function addBusinessDays(startDate, days) {
      let currentDate = new Date(startDate.getTime());
      let addedDays = 0;
      while (addedDays < days) {
        currentDate.setDate(currentDate.getDate() + 1);
        // Проверка, является ли текущий день выходным (суббота = 6, воскресенье = 0)
        if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
          addedDays++;
        }
      }
      return currentDate;
  }
});